import * as React from 'react'
import type { SVGProps, Ref } from 'react'
import { forwardRef } from 'react'
interface SVGRProps {
  title?: string
  titleId?: string
}
const SvgTriangleArrowUpRight = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns='http://www.w3.org/2000/svg'
    width='1em'
    height='1em'
    fill='none'
    viewBox='0 0 24 24'
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill={props.color}
      fillRule='evenodd'
      d='M17.074 15.636a1.5 1.5 0 0 1-1.635-.325l-2.315-2.315-4.564 4.565a1.5 1.5 0 0 1-2.121-2.122l4.564-4.564L8.69 8.561A1.5 1.5 0 0 1 9.749 6h6.75A1.5 1.5 0 0 1 18 7.5v6.75a1.5 1.5 0 0 1-.925 1.386'
      clipRule='evenodd'
    />
  </svg>
)
const ForwardRef = forwardRef(SvgTriangleArrowUpRight)
export default ForwardRef
